var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(-684 -261)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 32,
    height: 32,
    transform: "translate(684 261)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7",
    transform: "translate(685.775 262.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M24.078,8.018a.494.494,0,0,0-.359-.147l-2.857.012V3.527a.505.505,0,0,0-.505-.505H6.552A3.125,3.125,0,0,0,3.226,6.2V18.224c0,2.587.536,4.38,1.592,5.33a2.443,2.443,0,0,0,1.614.671c.038,0,.068,0,.089,0h17.2a.505.505,0,0,0,.505-.505V8.377A.505.505,0,0,0,24.078,8.018ZM6.552,4.033h13.3V7.887c-3.626.014-8.886.033-11.617.033-3.815,0-3.991-1.651-4-1.73A2.133,2.133,0,0,1,6.552,4.033ZM23.217,23.211l-16.759,0a1.425,1.425,0,0,1-.991-.437c-.561-.524-1.229-1.738-1.229-4.552V7.916a6.426,6.426,0,0,0,4,1.015c3.858,0,12.762-.038,14.982-.047Z",
    transform: "translate(0 0)",
    fill: "#707070"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.5b3aff85d047d0e7249c0814d1d457a7.svg";
export { ForwardRef as ReactComponent };